import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { getCourseBySlug, getTaskBySlug } from '../../api/apis';
import { Course } from '../../lib/interfaces/Course';
import MainLayout from '../Smart/Layouts/MainLayout';
import TaskSingle from './TaskSingle';
import TasksSidebarList from './TasksSidebarList';
import Loader from '../Simple/Loader/Loader';
import { Task } from '../../lib/interfaces/Task';
import { day } from '../../lib/helpers/time.helper';
import { useAppDispatch } from '../../hooks/redux';
import { setCourseParams } from '../../redux/reducers/ui/courseReducer';
import { preformatTaskContent } from './preformat.utils';

const TasksLayout: FC = () => {
	const { courseSlug = '', taskSlug = '' } = useParams();
	const { i18n } = useTranslation();
	const currentLanguage: string = i18n.language;
	const { data } = useQuery<Course, Error>([`course-${courseSlug}`], () =>
		getCourseBySlug(courseSlug),
	);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (data) {
			dispatch(setCourseParams(data));
		}

		return () => {
			dispatch(setCourseParams(null));
		};
	}, [data]);

	const currentTask = data?.tasks.find((task) => task.slug === taskSlug);

	const { data: taskData } = useQuery<Task, Error>(
		['task', taskSlug],
		() => getTaskBySlug(taskSlug),
		{
			enabled: !!taskSlug,
			staleTime: day,
		},
	);

	const content =
		data && currentTask && taskData ? (
			<TaskSingle
				course={data}
				task={preformatTaskContent(taskData, currentLanguage)}
			/>
		) : (
			<Loader />
		);

	const sidebar =
		data && currentTask ? (
			<TasksSidebarList course={data} currentTask={taskSlug} />
		) : (
			<div> </div>
		);

	return <MainLayout sidebar={sidebar} content={content} />;
};

export default TasksLayout;
